<template>
    <b-container class="pb-5 mb-5 flex-1">
        <b-row class="mt-5 mb-5">
            <b-col>
                <h2>Your Conferences</h2>
            </b-col>

<!--            <b-col class="text-right">-->
<!--                <b-button variant="success" :to="{name: 'new-conference'}"><i class="fas fa-plus-circle mr-2"></i>New Conference</b-button>-->
<!--            </b-col>-->
        </b-row>

        <b-row class="mt-5 mb-2">
            <b-col>
                <h4>Active Conferences</h4>
            </b-col>
        </b-row>

        <b-card class="conference mb-3" v-for="conf in active">
            <b-row>
                <b-col cols="7">
                    <h6>{{conf.title}} <b-badge variant="light" class="ml-3"><i class="fas fa-tag mr-2"></i>{{conf.code}}</b-badge></h6>
                    <div>{{conf.start_at | moment('dddd, MMMM Do, YYYY')}} - {{conf.end_at | moment('dddd MMMM Do, YYYY')}}</div>
                    <div>{{conf.registrations.length - conf.pending}} Registrations - {{conf.revenue | currency}} <span class="text-muted" v-if="conf.pending > 0">({{conf.pending}} for {{conf.pendingRevenue | currency}} pending)</span></div>
                </b-col>
                <b-col class="text-right">
                    <b-button variant="success" class="mr-2" :to="{name: 'conference-details', params: {id: conf.id}}"><i class="fas fa-search mr-2"></i> Details</b-button>
                </b-col>
            </b-row>
        </b-card>

        <b-row class="mt-5 mb-2">
            <b-col>
                <h4>Archived Conferences</h4>
            </b-col>
        </b-row>

        <b-card class="conference mb-3" v-for="conf in archived">
            <b-row>
                <b-col cols="7">
                    <h6>{{conf.title}} <b-badge variant="light" class="ml-3"><i class="fas fa-tag mr-2"></i>{{conf.code}}</b-badge></h6>
                    <div>{{conf.start_at | moment('dddd, MMMM Do, YYYY')}} - {{conf.end_at | moment('dddd MMMM Do, YYYY')}}</div>
                </b-col>
                <b-col class="text-right">
                    <b-button variant="success" class="mr-2" :to="{name: 'conference-details', params: {id: conf.id}}"><i class="fas fa-search mr-2"></i> Details</b-button>
                </b-col>
            </b-row>
        </b-card>

        <b-row class="mt-5 mb-2">
            <b-col>
                <h4>Quick Tools</h4>
            </b-col>
        </b-row>

        <b-card>
            <b-row>
                <b-col>
                    <h6 class="mb-3">Complete P.O. &amp; Activate Registration</h6>
                    <p class="mt-3 mb-4">
                        <i class="fas fa-info-circle mr-2"></i>Once the purchase order payment has been received you can quickly activate a registration with it's reference code.
                    </p>
                    <b-input-group>
                        <b-form-input placeholder="Reference Code (6 characters)" v-model="activateCode"></b-form-input>
                        <b-input-group-append>
                            <b-button variant="danger" @click="activate" :disabled="processing"><i class="fas fa-check mr-3"></i>Activate Registration</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-col>
            </b-row>
        </b-card>
    </b-container>
</template>


<script>
    import {mapGetters, mapActions} from 'vuex'
    import moment from "moment";

    export default {
        name: "org-dashboard",
        data() {
            return {
                conferences: [],
                activateCode: null,
                processing: false
            }
        },
        computed: {
            active: function() {
                let a = [];
                for (let i = 0; i < this.conferences.length; i++) {
                    const conference = this.conferences[i];
                    if (moment().isBefore(moment(conference.end_at).add(45, 'days'))) {
                        a.push(conference);
                    }
                }
                return a;
            },
            archived: function() {
                let a = [];
                for (let i = 0; i < this.conferences.length; i++) {
                    const conference = this.conferences[i];
                    if (moment().isAfter(moment(conference.end_at).add(45, 'days'))) {
                        a.push(conference);
                    }
                }
                return a;
            }
        },
        methods: {
            ...mapActions(['getConferences','activateReg']),
            activate() {
                if (confirm('Are sure you are ready to activate and complete this registration?  The purchase order process should be complete before activating.')) {
                    this.processing = true;
                    this.activateReg(this.activateCode).then(result => {
                        this.activateCode = '';
                        this.processing = false;
                    }, (err) => {
                        window.alert('That code doesn\'t appear to be valid.  Please try again.');
                        this.processing = false;
                    });
                }
            }
        },
        mounted: function () {
            this.getConferences().then(results => {
                this.conferences = results;
            });

            console.log(moment().add(3, 'months'));
        }
    }
</script>


<style lang="scss" scoped>
    @import '~@/assets/scss/_variables.scss';
</style>
